import { useBkurl } from '~/hooks/useBkurl'

type Props = {
  isFollowing: boolean
  follow?: () => void
  unfollow?: () => void
  beLoginLink?: boolean
}

export const FollowButton: React.FC<Props> = ({
  isFollowing,
  unfollow,
  follow,
  beLoginLink,
}) => {
  const bkurl = useBkurl()
  const baseClassName =
    'flex size-full items-center justify-center rounded-full font-semibold leading-normal xl:hover:opacity-70'
  if (beLoginLink)
    return (
      <a
        href={`/login/?bkurl=${bkurl}`}
        className={`${baseClassName} bg-blue-400 text-white`}
      >
        フォローする
      </a>
    )
  if (isFollowing)
    return (
      <button
        type="button"
        onClick={unfollow}
        className={`${baseClassName} bg-gray-200 text-black`}
      >
        フォロー中
      </button>
    )
  return (
    <button
      type="button"
      onClick={follow}
      className={`${baseClassName} bg-blue-400 text-white`}
    >
      フォローする
    </button>
  )
}
